<template>
  <div class="footnav">
    <img src="/static/img/footnav.png" alt="" />
    <div class="title">宁波海贸供应链管理有限公司</div>
    <div class="title1">Ningbo Hitrans Supply Chain Management Co., Ltd.</div>
    <div class="footbg">
      <!-- <span class="ttext"> {{ F.service }}</span> -->
      <span @click="toserE(0)">{{ F.transport }} </span>
      <span @click="toserE(1)"> {{ F.clearance }} </span>
      <span @click="toserE(2)">{{ F.bulk }}</span>
      <span @click="toserE(3)">{{ F.warehousing }}</span>
      <span @click="toserE(4)"> {{ F.cargo }} </span>
      <span @click="toserE(5)">{{ F.project }}</span>
    </div>
    <div class="qrcode">
      <div class="left"><img src="/static/img/qrcode.png" alt="" /></div>
      <div class="right">
        <div>
          <span>{{ F.tel }}</span
          >13216608607
        </div>
        <div>
          <span>{{ F.email }}</span
          >eileen.song@hitransgroup.com
        </div>
      </div>
    </div>

    <div class="ba" @click="clickE">浙ICP备2022026684号-1</div>
  </div>
</template>

<script>
import text from "../../static/data/text";
export default {
  data() {
    return {
      lan: "cn"
    };
  },
  computed: {
    F() {
      return text[this.lan]["footer"];
    }
  },
  methods: {
    toserE(index) {
      this.$router.push({ path: "/services", query: { num: index } });
    },
    clickE() {
      window.open("https://beian.miit.gov.cn");
    }
  }
};
</script>
<style scoped>
.ba {
  color: #fff;
  cursor: pointer;
  margin-top: 20px;
}
.footnav {
  height: 970px;
  background: #164197;
  padding-top: 112px;
  padding-bottom: 135px;
  text-align: center;
  box-sizing: border-box;
}
.footnav .title {
  font-size: 45px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  margin-top: 23px;
}
.title1 {
  font-size: 21px;
  font-family: Source Han Sans CN-Light, Source Han Sans CN;
  font-weight: 300;
  color: #ffffff;
  margin-top: 23px;
  margin-bottom: 76px;
}
.footbg {
  height: 156px;
  background: url("/static/img/footbg.png") no-repeat;
  padding: 0 272px;
  box-sizing: border-box;
  font-size: 30px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 54px;
  line-height: 156px;
}

.footbg .ttext {
  font-size: 24px;
  margin-right: 0;
}
.footbg span {
  margin-right: 40px;
}
.footbg span:hover {
  color: #3472ef;
  cursor: pointer;
}
.footbg .ttext:hover {
  color: #ffffff;
  cursor: pointer;
}
.qrcode {
  margin-top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 65px;
}
.qrcode .right {
  margin-left: 73px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/footnav.vue